<ng-form #stepForm="ngForm">
    <!-- bank details -->
    <h3 class="h3">{{'Bank Details' | translate}}</h3>

    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="bank_name"
               required
               sl-input="bank_name"
               [(ngModel)]="data.bank_name"
               [muiInput]="'Bank Name' | translate">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                  style="resize:none;"
                  name="branch_address"
                  required
                  sl-input="branch_address"
                  [(ngModel)]="data.branch_address"
                  [muiInput]="'Branch Address' | translate"></textarea>
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="bank_postcode"
               required
               sl-input="bank_postcode"
               [(ngModel)]="data.bank_postcode"
               [muiInput]="'Postcode' | translate">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="account_name"
               required
               sl-input="account_name"
               [(ngModel)]="data.account_name"
               [muiInput]="'Account Name' | translate">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="account_number"
               required
               sl-input="account_number"
               [(ngModel)]="data.account_number"
               [muiInput]="'Account Number' | translate">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="sortcode"
               sl-input="sortcode"
               [(ngModel)]="data.sortcode"
               [muiInput]="'Sort code' | translate"
               required>
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s"
                #datepickerRef>
        <datepicker [name]="'date_opened'"
                    [required]="true"
                    [readonly]="true"
                    [placeholder]="'Date Opened' | translate"
                    [options]="calendarOptions"
                    [(ngModel)]="dateOpened"
                    (valueChange)="valueChangeHandler($event)"></datepicker>
    </input-wrap>
</ng-form>